module.exports = __webpack_public_path__ + "media/tip.b69d58b5.mp3";